import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'VGTropics One Health';

}



// WEBPACK FOOTER //
// /Users/bdegroot/Projects/vgtropics-ph/src/app/app.component.ts